
function prefetch(e) {
  // Check if the target is an anchor element
  if (e.target.tagName != "A") {
    return;
  }

  if (e.target.origin != location.origin) {
    return;
  }

  /**
   * Return the given url with no fragment
   * @param {string} url potentially containing a fragment
   * @return {string} url without fragment
   */
  const removeUrlFragment = (url) => url.split("#")[0];

  if (removeUrlFragment(window.location.href) === removeUrlFragment(e.target.href)) {
    return;
  }

  var l = document.createElement("link");
  l.rel = "prefetch";
  l.href = e.target.href;
  document.head.appendChild(l);
}

document.documentElement.addEventListener("mouseover", prefetch, {
  capture: true,
  passive: true,
});

document.documentElement.addEventListener("touchstart", prefetch, {
  capture: true,
  passive: true,
});